require('./indians');
require('./wdEventCommon');
window.$wdEventCommon.setType('wrongDoings');

require('./registry');

export class WrongDoing {
	defaultOptions() {
		return {
			id: null,
			displayVehicle: true,
			show: false,
			wizardStep: 0,
			wizardSteps: {
				photo: 0,
				description: 1,
				stagecoach: 3,
			},
			private: {
				displayVehicle: true,
			},
		};
	}

	constructor() {
		var options = $('#js-opts').data('wrongDoing');
		this.$options = $.extend({}, this.defaultOptions(), options || {});
		
		this.handleButtons();
		$('#wrongDoingsForm').validator();

		window.$wdEventCommon.setId(this.$options.id);
	}

	//=====================================================================
	// Wrong doing specific methods
	//=====================================================================

	wizardOnDescription() {
		return (this.$options.wizardStep === this.$options.wizardSteps.description);
	}
	
	enableCreatedAtEdit() {
		$('#createdAt').removeAttr('disabled');
		$('#createdAtEnabled').val('1').trigger('change');
	}
	
	checkPrint(event) {
		if (event.ctrlKey && (event.keyCode == 80))	//ctrl+p
		{
			var $button = $('#printButton');
			if ($button.length > 0)
			{
				event.preventDefault();
				window.open($('#printButton').attr('href'));
			}
		}
	}
	
	toggleSolvedByEdit($elem) {
		$elem.addClass('hidden');
		$('#solved_by-select').removeClass('hidden');
		$('#solvedBy').removeAttr('disabled');
	}

	checkDuplicity() {
		var app = this,
			rz = $('#licensePlate').val(),
			date = $('#time_date').val(),
			id = app.$options.id,
			url = route('wrongDoings.checkDuplicity', {}),
			lang = $Lang.wrongDoings;
		if (rz && date)
		{
			$.ajax({
				url: url,
				dataType: 'json',
				data: {
					rz : rz,
					date : date,
					id : id,
				},
				method: 'post',
				success(response) {
					if (response.isDuplicate)
					{
						var message = lang.isDuplicate
							.replace(":rz", rz)
							.replace(":date", date);
						bootbox.confirm({
							message: message,
							buttons: {
								confirm: {
									label: 'Ano',
									className: 'btn-success'
								},
								cancel: {
									label: 'Ne',
									className: 'btn-danger'
								}
							},
							callback(result) {
								/*if (!result) {
									window.setTimeout(function () { $('input#licensePlate').focus().select(); }, 10);
								}*/
							}
						});
					}
				},
			});
		}
	}

	//=====================================================================

	//=====================================================================

	wizardNextStep() {
		var app = this,
			steps = app.$options.wizardSteps,
			$panelPoster = $('.panel.wd-poster'),
			$panelDescription = $('.panel.wd-description'),
			$panelStagecoach = $('.panel.wd-stagecoach'),
			$btnNext = $('.js-wizard-next-step'),
			$btnSave = $('.js-wizard-save'),
			$lpSelect = $('#licensePlate'),
			rzs = window.$filesControls.getRZ();
		switch (app.$options.wizardStep) {
			case steps.photo:
				app.$options.wizardStep = steps.description;
				$panelPoster.addClass('hidden');
				$panelDescription.removeClass('hidden');
				$('.js-wizard-prev-step').removeClass('hidden');
				if (!app.$options.private.displayVehicle) {
					$btnNext.addClass('hidden');
					$btnSave.removeClass('hidden');
				}
				break;
			case steps.description:
				app.$options.wizardStep = steps.stagecoach;
				$panelDescription.addClass('hidden');
				$panelStagecoach.removeClass('hidden');
				$btnNext.addClass('hidden');
				$btnSave.removeClass('hidden');
				
				if (!$lpSelect.val() && (rzs.length > 0)) {
					window.$wdEventCommon.updateRzWhisperer($lpSelect);
					$lpSelect.val(rzs[0].rz).trigger('change');
				}
				
				break;
			default:
				break;
		}
	}

	wizardPrevStep() {
		var app = this,
			steps = app.$options.wizardSteps,
			$panelPoster = $('.panel.wd-poster'),
			$panelDescription = $('.panel.wd-description'),
			$panelStagecoach = $('.panel.wd-stagecoach'),
			$btnNext = $('.js-wizard-next-step'),
			$btnSave = $('.js-wizard-save');
		switch (app.$options.wizardStep) {
			case steps.stagecoach:
				app.$options.wizardStep = steps.description;
				$panelDescription.removeClass('hidden');
				$panelStagecoach.addClass('hidden');
				$btnNext.removeClass('hidden');
				$btnSave.addClass('hidden');
				break;
			case steps.description:
				app.$options.wizardStep = steps.photo;
				$panelPoster.removeClass('hidden');
				$panelDescription.addClass('hidden');
				$('.js-wizard-prev-step').addClass('hidden');
				$btnNext.removeClass('hidden');
				$btnSave.addClass('hidden');
				break;
			default:
				break;
		}
	}

	wizardUpdateButtons(displayVehicle) {
		var options = this.$options,
			$btnNext = $('.js-wizard-next-step'),
			$btnSave = $('.js-wizard-save');
		
		options.private.displayVehicle = displayVehicle;
		if (options.wizardStep === options.wizardSteps.description) {
			if (!displayVehicle) {
				$btnNext.addClass('hidden');
				$btnSave.removeClass('hidden');
			} else {
				$btnNext.removeClass('hidden');
				$btnSave.addClass('hidden');
			}
		}
	}
	
	//=====================================================================

	processPIDScan(data) {
		if ("num" in data) {
			$('#pid').val(data.num);
		}
	}
	
	recurrenceOutsideViolet(isSet) {
		if (isSet) {
			$('#recurrenceMonitoringNumber').removeAttr('readonly');
		} else {
			$('#recurrenceMonitoringNumber').attr('readonly', 'readonly');
		}
	}

	//=====================================================================

	/**
	 * HANDLE BUTTONS
	 */
	handleButtons() {
		var app = this,
			$document = $(document);

		if (!app.$options.show)
		{
			
			$document.on('click', '.js-edit-created-at', function () {
				app.enableCreatedAtEdit();
			});
			
			$document.on('click', '.js-solved-by-editable', function () {
				app.toggleSolvedByEdit($(this));
			});

			$document.on('change', '.js-check-duplicity', function () {
				app.checkDuplicity();
			});
			
			$document.on('click', '.js-wizard-next-step', function(e) {
				e.preventDefault();
				app.wizardNextStep();
			});
			$document.on('click', '.js-wizard-prev-step', function(e) {
				e.preventDefault();
				app.wizardPrevStep();
			});
			
			$document.on('change', '#recurrenceOutsideViolet', function () {
				app.recurrenceOutsideViolet(this.checked);
			});

			$document.on('pidScanEvent', function (e) {
				app.processPIDScan(e.detail);
			});
			
			if (window.$positionController) {
				$document.on('click', '#coordinates-button', function (e) {
					e.preventDefault();
					window.$positionController.coordinatesButtonClick();
				});

				$document.on('change', '#lat, #lon', function () {
					window.$positionController.fillClosestTrails();
				});
			}
		}
	}
}

